module.exports = __webpack_public_path__ + "static/media/avatar28.aded985c.png";